import { NewWriterPopularTable } from './NewWriterPopularTable'
import { withNewWriterPopularTable } from './withNewWriterPopularTable'

const Connected = withNewWriterPopularTable(NewWriterPopularTable)

export { Connected as NewWriterPopularTable }
